import { useMutation } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

// Mints a Stripe Dashboard login link. The backend 409s when the account's
// Stripe Dashboard type doesn't support a login link — the caller treats that
// as "no dashboard available", not an error, so the global error toast is
// skipped here too.
export const useStripeDashboardLink = () => {
  const tenantVal = localStorage.getItem("kinesin-tenant");

  return useMutation({
    meta: { skipGlobalError: true },
    mutationFn: async () => {
      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.post(
        `${tenantVal}/stripe/dashboard-link`
      );
      return response.data;
    },
  });
};
